import React, { useRef, useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router';
import { formPreview } from '../../../../../helpers/RxServices';
import { useSelector } from 'react-redux';
import { AppState } from '../../../../../stateManager/store';
import { Param } from '../../../../../helpers/routeParams';
import style from './preview.module.sass';
import { IframeURL, IframeTargetOrigin } from '../../../../../constant/common';
import { ScannerDrawer } from '../../../../../helpers/commonUi'
import { SignaturePadModal } from '../create/components/signaturePad/signaturePadModal'
import { Tabs } from 'antd';

const { TabPane } = Tabs;

export const Preview = () => {
  formPreview.sendMessage({
    hide: { preview: true, save: true, morePopver: true },
  });
  let frameref: any = useRef();
  let [getframeref, setgetframeref]: any = useState(false);
  let [tabInfo, setTabInfo]: any = useState(null);
  const [iframeHeight, setIframeHeight] = useState(100);
  const params = useParams<Param>();
  const history: any = useHistory();

  const forms = useSelector(
    (state: AppState) => state.formcreation[params.formId!]
  );
  const selectedApp = useSelector((state: AppState) => state.apps.selectedApp);
  const appsList = useSelector((state: AppState) => state.apps.appsList);
  const assetsList = useSelector((state: AppState) => state.assets.list);

  useEffect(() => {
    setgetframeref(frameref);
    window.addEventListener("message", a8FlowListener);
  }, [frameref]);

  useEffect(() => {
    const redirect = !appsList.find((el: any) => el.appId === params.appId);
    if (redirect) {
      history.push("/404")
    }
  }, [history, appsList, params.appId])

  const a8FlowListener = (e: any) => {
    let { data } = e;
    if (data.action === "initial") {
      setTabInfo(data.tabInfo);
    } else if (data.iframeHeight) {
      setIframeHeight(data.iframeHeight);
    }
  };

  const onframeLoad = () => {
    setgetframeref(frameref);
    // embed the assets in the form json
    forms[0].assets = assetsList
    frameref.contentWindow.postMessage(
      { studioPreview: forms, formKey: params.formId, init: true },
      IframeTargetOrigin
    );
  };

  const handleTabClick = (tab: any) => {
    setTabInfo({ ...tabInfo, activeTab: tab });
    frameref.contentWindow.postMessage({ activeTab: tab }, IframeTargetOrigin);
  };

  return (
    <React.Fragment>
      {
        <>
          {forms ? (
            <>
              {selectedApp.type !== "a8assist" && (
                <Tabs
                  data-test-id="a8assist"
                  className={"Prev_tab"}
                  activeKey={tabInfo && tabInfo.activeTab}
                  onTabClick={handleTabClick}
                >
                  {tabInfo &&
                    tabInfo.tabList.map((tab: any) => (
                      <TabPane
                        data-test-id={`preview_tab${tab.tabkey}`}
                        style={{ margin: "0px" }}
                        tab={tab.label}
                        key={tab.tabKey}
                      ></TabPane>
                    ))}
                </Tabs>
              )}
              <div
                data-test-id="preview"
                style={{
                  border: "1px solid #DEE5F4",
                  borderRadius: "4px",
                  overflow: "scroll",
                  height: "70vh",
                }}
              >
                <iframe
                  data-test-id="preview_iframe"
                  ref={(ref) => (frameref = ref)}
                  width={`100%`}
                  id="iframe"
                  style={{ overflow: "auto", minHeight: "700px" }}
                  height={iframeHeight}
                  title="s"
                  className={style.iframe}
                  src={IframeURL}
                  onLoad={onframeLoad}
                ></iframe>
              </div>
            </>
          ) : null}
        </>
      }
      {getframeref && <ScannerDrawer data-test-id="scanner_drawer" ipc={getframeref} />}
      <SignaturePadModal />
    </React.Fragment>
  );
};
